<template>
    <span class="grey-9--text page-text--sm line-height-15"> {{ startsAt }} ~ {{ endsAt }} {{ daysLeft }} </span>
</template>

<script>
import dayjs from "dayjs";

const days = ["일", "월", "화", "수", "목", "금", "토"];

export default {
    props: {
        value: { type: Object, default: () => ({}) }, // meeting
    },
    computed: {
        startsAt() {
            let { startsAt } = this.value?.matching || {};
            return startsAt ? `${dayjs(startsAt).format("YYYY.MM.DD")}(${days[dayjs(startsAt).day()]})` : null;
        },
        endsAt() {
            let { endsAt } = this.value?.matching || {};
            return endsAt ? `${dayjs(endsAt).format("YYYY.MM.DD")}(${days[dayjs(endsAt).day()]})` : null;
        },
        daysLeft() {
            let { daysLeft } = this.value?.matching || {};
            if (Number.isNaN(daysLeft)) return "상시모집";

            if (daysLeft < 0) return `D${daysLeft}`;
            if (daysLeft == 0) return "D-Day";
            if (daysLeft > 0) return "마감";
        },
    },
};
</script>

<style></style>
